(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 86756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(53995);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$$default": function() { return /* binding */ register_bs_$$default; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register_bs_$$default; },
  "wrapper": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./src/components/library/SeoMeta.bs.js
var SeoMeta_bs = __webpack_require__(81036);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/layouts/OnboardingLayout.bs.js
var OnboardingLayout_bs = __webpack_require__(8103);
// EXTERNAL MODULE: ./src/components/pages/register/RegisterComponent.bs.js + 10 modules
var RegisterComponent_bs = __webpack_require__(8932);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pages/register/SignUpOnboardingStyles.bs.js
var SignUpOnboardingStyles_bs = __webpack_require__(73131);
;// CONCATENATED MODULE: ./src/components/pages/register/SignUpOnboarding.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








function SignUpOnboarding(props) {
    return jsx_runtime.jsxs(OnboardingLayout_bs/* make */.S, {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("p", {
                        children: util_bs/* ReactStuff.s */.p_.s("Already registered?"),
                        className: "text-light-gray text-sm mr-2"
                    }),
                    jsx_runtime.jsx((link_default()), {
                        href: "/login",
                        prefetch: false,
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Log in"),
                            "aria-label": "Login",
                            className: Cn_bs/* make */.S([
                                SignUpOnboardingStyles_bs/* loginBtn */.PV,
                                Button_bs/* primaryOutlineStyle */.e1
                            ])
                        })
                    })
                ],
                className: "flex items-center float-right mr-4 lg:mr-10"
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(RegisterComponent_bs.make, {
                    signupType: /* SignupPage */ 4
                }),
                className: SignUpOnboardingStyles_bs/* signUpContainer */.Gf
            })
        ],
        onboardingKind: /* ShowFeatures */ 0
    });
}
var Link$1;
var make = SignUpOnboarding;
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/register/register-lazy.js


var register = dynamic_default()(function() {
    return Promise.resolve(make);
}, {
    ssr: false
});
var $$default = register;


;// CONCATENATED MODULE: ./src/components/pages/register/RegisterLazy.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var RegisterLazy_bs_make = $$default;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./src/utils/PageContentResolver.bs.js
var PageContentResolver_bs = __webpack_require__(73763);
;// CONCATENATED MODULE: ./src/pages/register.bs.js
__webpack_require__(14473);
// Generated by ReScript, PLEASE EDIT WITH CARE





function Register$wrapper(props) {
    var registerContent = PageContentResolver_bs/* parse */.Qc(props.content);
    var f_seo_meta = function f_seo_meta(v) {
        return jsx_runtime.jsx(SeoMeta_bs/* make */.S, {
            meta: v.VAL
        });
    };
    var seo_meta = registerContent !== undefined ? belt_Option/* mapWithDefault */.k7(registerContent.seo_meta, null, f_seo_meta) : null;
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            seo_meta,
            jsx_runtime.jsx(RegisterLazy_bs_make, {})
        ]
    });
}
var wrapper = Register$wrapper;
var register_bs_$$default = Register$wrapper;
var __N_SSP = true;
 /* SeoMeta Not a pure module */ 


/***/ }),

/***/ 47800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p5": function() { return /* binding */ ssr_page_cache; },
/* harmony export */   "yN": function() { return /* binding */ no_cache; }
/* harmony export */ });
/* unused harmony export product_ssr_page_cache */
// Generated by ReScript, PLEASE EDIT WITH CARE
var ssr_page_cache = "public, max-age=600, stale-while-revalidate=300, stale-if-error=1800";
var product_ssr_page_cache = "public, max-age=90, stale-while-revalidate=300, stale-if-error=1800";
var no_cache = "private, no-cache, no-store, max-age=0, must-revalidate";
 /* No side effect */ 


/***/ }),

/***/ 75897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadAppleApp(props) {
    var baseHref = "https://itunes.apple.com/au/app/prezzee/id1047060902";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref.replace("au", _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_apple_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full ml-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadAppleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadGoogleApp(props) {
    var baseHref = "https://play.google.com/store/apps/details?id=com.prezzee.prezzee";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref + ("&gl=" + _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_play_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full mr-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadGoogleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 81036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Head */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function SeoMeta(props) {
    var meta = props.meta;
    var router = next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter();
    var match = meta.seoMetaOgType.length;
    var ogType = match !== 0 ? meta.seoMetaOgType : "website";
    var ogImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .mapWithDefault */ .k7(meta.seoMetaOgImageAsset, "", function(b) {
        return b.url;
    });
    var twImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(meta.seoMetaTwImageAsset, function(b) {
        return b.url;
    });
    var twImageUrl = twImageAssetUrl !== undefined ? twImageAssetUrl : meta.seoMetaTwImageAssetUrl;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: meta.seoMetaBasicTitle,
                description: meta.seoMetaBasicDescription,
                canonical: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getCanonicalUrl */ .br.getCanonicalUrl(router.asPath),
                languageAlternates: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getLanguageAlternates */ .br.getLanguageAlternates(router.asPath),
                openGraph: {
                    title: meta.seoMetaOgTitle,
                    description: meta.seoMetaOgDescription,
                    url: meta.seoMetaOgUrl
                }
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogImageAssetUrl,
                        property: "og:image"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogType,
                        property: "og:type"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwTitle,
                        property: "twitter:title"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwDescription,
                        property: "twitter:description"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: "summary_large_image",
                        property: "twitter:card"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: router.pathname,
                        property: "twitter:url"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: twImageUrl,
                        property: "twitter:image"
                    })
                ]
            })
        ]
    });
}
var Head$1;
var make = SeoMeta;
 /* Util Not a pure module */ 


/***/ }),

/***/ 8103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export features */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96533);
/* harmony import */ var _components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30369);
/* harmony import */ var _components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75897);
/* harmony import */ var _components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59195);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE







var features = [
    "Keep all my eGift cards in one place",
    "Fast access from my phone while I shop",
    "Secure digital wallet",
    "Get offers",
    "Send gift cards even faster"
];
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var onboardingKind = props.onboardingKind;
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var deviseImg;
    deviseImg = match.TAG === /* Ok */ 0 && match._0 === 3 ? {
        width: 448,
        height: 265,
        src: "/images/laptop_wallet.png",
        alt: "Prezzee wallet"
    } : {
        width: 448,
        height: 275,
        src: "/images/prezzee_desktop_wallet.png",
        alt: "Prezzee wallet"
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: typeof onboardingKind === "number" ? onboardingKind !== 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("h2", {
                                    children: [
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Never forget a"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift card again.")
                                    ],
                                    className: "font-semibold text-3xl text-white mb-4 "
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("p", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Buy, send and store ")
                                        }),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift cards, all"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("with a few clicks in the Prezzee App."),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Download for free now.")
                                        })
                                    ],
                                    className: "text-lg text-white font-thin leading-relaxed mb-8"
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                                            className: "mr-3 w-32"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                                            className: "ml-3 w-32"
                                        })
                                    ],
                                    className: "flex"
                                })
                            ],
                            className: ""
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                src: "/images/prezzee_mobile_app.png",
                                alt: "Prezzee iOS and Android mobile applications",
                                width: 448,
                                height: 457,
                                className: "max-w-md w-full h-auto py-6 my-auto"
                            }),
                            className: "flex-grow flex"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("ul", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.ate */ .p_.ate(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(features, function(index, feature) {
                                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("li", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                                src: "/images/icon_tick.svg",
                                                alt: feature,
                                                width: 20,
                                                height: 20
                                            }),
                                            className: "mt-1 mr-4"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("span", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(feature),
                                            className: "block w-full max-w-xs"
                                        })
                                    ],
                                    className: "flex mb-8"
                                }, "index-" + String(index));
                            })),
                            className: "flex-grow text-white text-xl"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: deviseImg.src,
                            alt: deviseImg.alt,
                            width: deviseImg.width,
                            height: deviseImg.height,
                            className: "max-w-md w-full h-auto py-6 mt-auto"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(onboardingKind._0, function(i, text) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("h2", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(text),
                                className: "font-bold text-4xl text-white text-center"
                            }, "title" + String(i));
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: "/images/presents.svg",
                            alt: "Presents",
                            width: 518,
                            height: 303,
                            className: "w-full pt-20 flex-grow"
                        })
                    ]
                }),
                className: "hidden w-full lg:flex flex-col lg:w-1/3 py-20 pb-5 px-5 bg-prezzee-red"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: props.children,
                className: "w-full lg:w-2/3 bg-white text-center py-5"
            })
        ],
        className: "flex flex-wrap-reverse w-full"
    });
});
 /* make Not a pure module */ 


/***/ }),

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "UW": function() { return /* binding */ resolver; }
/* harmony export */ });
/* unused harmony export modifyBlocks */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94518);
/* harmony import */ var _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47800);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23328);
// Generated by ReScript, PLEASE EDIT WITH CARE












function modifyBlocks(prim0, prim1, prim2) {
    return ModifyBlocks.modifyBlocks(prim0, prim1, prim2);
}
function resolver(ctx, url, param) {
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"))) {
        ctx.res.setHeader("Cache-Control", _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .ssr_page_cache */ .p5);
    }
    var isPreview = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"));
    var i = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "lang");
    var language = i !== undefined ? i : null;
    var path = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__/* .split */ .Vl("?", ctx.resolvedUrl), 0);
    var queryUrl = url !== undefined ? url : path !== undefined ? path : "";
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(res) {
        var content = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(res, function(p) {
            return p.content;
        });
        var result = _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__/* .fromOption */ .Yo(JSON.stringify(content));
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(modifiedResult) {
            return Promise.resolve({
                props: {
                    content: modifiedResult
                }
            });
        }, _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__/* .modifyBlocks */ .IN(result, isPreview, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language)));
    }, _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getPageContent */ .nW(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language), isPreview, queryUrl));
}
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
 /* Util Not a pure module */ 


/***/ }),

/***/ 50857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QX": function() { return /* binding */ generateUniqueUserId; }
/* harmony export */ });
/* unused harmony exports getGiftTheme, isEmptyValue, getSegmentCompletedOrderProduct, BuyFor, getCheckoutStartedProduct, sendSegmentCheckoutStarted, customThemeImageUrlExists, setSelectedThemeData, getProductFromCard, sendSegmentCompletedOrder, useProductPageSegment */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25934);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73840);
/* harmony import */ var _FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43243);
// Generated by ReScript, PLEASE EDIT WITH CARE











function getGiftTheme(giftThemeData, giftThemeUid) {
    return Belt_Option.mapWithDefault(giftThemeData, "", function(t) {
        var theme = Belt_Array.getBy(t.giftThemes, function(s) {
            return s.uid === FormHelpers.getValue(giftThemeUid);
        });
        return Belt_Option.mapWithDefault(theme, "", function(theme) {
            return theme.title;
        });
    });
}
function isEmptyValue(value) {
    if (Caml_obj.equal(value, "")) {
        return true;
    } else {
        return value === null;
    }
}
function getSegmentCompletedOrderProduct(formValues, themes, card, href) {
    var giftTheme = getGiftTheme(themes, formValues.giftThemeUid);
    var doesThemeExistInTemplates = Belt_Array.some(card.themes, function(x) {
        return x.uid === formValues.themeUid;
    });
    var isCustomSkuThemeDesign = doesThemeExistInTemplates ? "false" : "true";
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        gift_theme: giftTheme,
        price: Belt_Int.fromString(formValues.value),
        sku_theme_design_uid: formValues.themeUid,
        is_custom_sku_theme_design: isCustomSkuThemeDesign
    });
}
function getSegmentBuyForKey(state) {
    var match = state.senderAlias;
    if (typeof match !== "number") {
        return "anonymousgift";
    }
    switch(match){
        case /* Myself */ 0:
            return "myself";
        case /* Gift */ 1:
            return "gift";
        case /* SenderAliasNotSelected */ 2:
            return "";
    }
}
function makeSegmentData(state, purchaseInstanceId) {
    return {
        step_name: "PCbuyingFlowSelectSelfPurchaseOrGift",
        buy_for: getSegmentBuyForKey(state),
        purchase_instance_id: purchaseInstanceId,
        step: 1
    };
}
function callbackIfTypeSelected(state, segmentCallback, purchaseInstanceId) {
    var match = state.senderAlias;
    if (typeof match === "number" && match >= 2) {
        return false;
    }
    var trackingObj = makeSegmentData(state, purchaseInstanceId);
    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(segmentCallback, trackingObj);
    return true;
}
var BuyFor = {
    getSegmentBuyForKey: getSegmentBuyForKey,
    makeSegmentData: makeSegmentData,
    callbackIfTypeSelected: callbackIfTypeSelected
};
function getCheckoutStartedProduct(card, href, state) {
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        price: Belt_Int.fromString(Belt_Option.getWithDefault(state.purchasePrice, "0"))
    });
}
function sendSegmentCheckoutStarted(product, value, callback, purchaseInstanceId) {
    Curry._1(callback, {
        affiliation: "consumer",
        total: Belt_Int.fromString(Belt_Option.getWithDefault(value == null ? undefined : Caml_option.some(value), "0")),
        currency: "NZD",
        purchase_instance_id: purchaseInstanceId,
        products: [
            product
        ]
    });
}
function customThemeImageUrlExists(imageUrl) {
    return Belt_Option.mapWithDefault(imageUrl == null ? undefined : Caml_option.some(imageUrl), "false", function(image) {
        if (image === "") {
            return "false";
        } else {
            return "true";
        }
    });
}
function setSelectedThemeData(product, card, themeUid, customThemeUid, customThemeImageUrl) {
    var defaultTheme = Belt_Option.mapWithDefault(themeUid == null ? undefined : Caml_option.some(themeUid), undefined, function(themeUid) {
        return Belt_Array.getBy(card.themes, function(theme) {
            return theme.uid === themeUid;
        });
    });
    if (defaultTheme !== undefined) {
        return Object.assign(product, {
            image_uid: defaultTheme.uid,
            image_url: defaultTheme.image,
            image_card_upload: "false"
        });
    }
    var imageUid = Belt_Option.mapWithDefault(customThemeUid == null ? undefined : Caml_option.some(customThemeUid), "", function(themeUid) {
        return themeUid;
    });
    var imageUrl = Belt_Option.mapWithDefault(customThemeImageUrl == null ? undefined : Caml_option.some(customThemeImageUrl), "", function(themeImageUrl) {
        return themeImageUrl;
    });
    return Object.assign(product, {
        image_uid: imageUid,
        image_url: imageUrl,
        image_card_upload: customThemeImageUrlExists(customThemeImageUrl)
    });
}
function getProductFromCard(formValues, themes, card, href) {
    var giftTheme = getGiftTheme(themes, formValues.giftThemeUid);
    var doesThemeExistInTemplates = Belt_Array.some(card.themes, function(x) {
        return x.uid === formValues.themeUid;
    });
    var isCustomSkuThemeDesign = doesThemeExistInTemplates ? "false" : "true";
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        gift_theme: giftTheme,
        price: Belt_Int.fromString(formValues.value),
        sku_theme_design_uid: formValues.themeUid,
        is_custom_sku_theme_design: isCustomSkuThemeDesign
    });
}
function sendSegmentCompletedOrder(state, formValues, orderResultUid, orderResultTotal, product, callback, purchaseInstanceId) {
    var coupon = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.promo), "", function(p) {
        return p.promoCode;
    });
    var buyFor = getSegmentBuyForKey(state);
    var giftMediaUid = formValues.giftMediaUid;
    var videoMessage = giftMediaUid == null ? "false" : "true";
    var scheduledDeliveryAt = formValues.scheduledDeliveryAt;
    var deliveryMethod = scheduledDeliveryAt == null ? "now" : "schedule";
    var reciContactShared = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.phone), "false", function(phone) {
        if (phone.number !== "") {
            return "true";
        } else {
            return "false";
        }
    });
    var guestEmailCtx = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.guestEmail), {}, function(p) {
        return {
            traits: {
                email: p
            }
        };
    });
    var ttclid = localStorage.getItem("ttclid");
    var ttclid$1 = ttclid == null ? undefined : Caml_option.some(ttclid);
    localStorage.removeItem("ttclid");
    var defaultProps = {
        coupon: coupon,
        buy_for: buyFor,
        video_message: videoMessage,
        gift_theme_uid: formValues.giftThemeUid,
        delivery_method: deliveryMethod,
        recipient_phonedetail_fields: reciContactShared,
        purchase_instance_id: purchaseInstanceId,
        order_number: orderResultUid,
        affiliation: "consumer",
        total: Belt_Int.fromString(orderResultTotal),
        currency: "NZD",
        products: [
            product
        ],
        server_region: "NZ",
        store: "consumer"
    };
    var props = Js_option.isNone(ttclid$1) || ttclid$1 === "" ? defaultProps : Object.assign(defaultProps, {
        ttclid: ttclid$1
    });
    return Curry._2(callback, props, guestEmailCtx);
}
function generateUniqueUserId(param) {
    var timeStamp = Date.now().toString();
    var uuid = uuid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
    return timeStamp.concat(uuid);
}
function useProductPageSegment(state, card, form, step1Callback, purchaseInstanceId, preselectedValue) {
    var value = Curry._2(form.watch, "value", preselectedValue);
    var prevValue = React.useRef(value);
    var themeUid = Curry._2(form.watch, "themeUid", "");
    var customThemeUid = Curry._2(form.watch, "customThemeUid", "");
    var customThemeImageUrl = Curry._2(form.watch, "customThemeImageUrl", "");
    var sendSegmentProductAdded = function sendSegmentProductAdded(card) {
        Segment.productAdded(setSelectedThemeData(Object.assign(Segment.cardToProductNoImageUrl(card), {
            url: document.location.href,
            purchase_instance_id: purchaseInstanceId,
            price: Belt_Int.fromString(Belt_Option.getWithDefault(value == null ? undefined : Caml_option.some(value), "0")),
            store: "consumer"
        }), card, themeUid, customThemeUid, customThemeImageUrl));
    };
    React.useEffect(function() {
        setTimeout(function(param) {
            if (preselectedValue !== "") {
                return sendSegmentProductAdded(card);
            }
        }, 700);
    }, []);
    React.useEffect(function() {
        if (state.senderAlias !== /* SenderAliasNotSelected */ 2) {
            var product = getCheckoutStartedProduct(card, document.location.href, state);
            sendSegmentCheckoutStarted(product, value, Segment.checkoutStarted, purchaseInstanceId);
            Curry._3(step1Callback, state, Segment.checkoutStepCompleted, purchaseInstanceId);
        }
    }, [
        state.senderAlias
    ]);
    React.useEffect(function() {
        var match = state.orderResult;
        var orderSent = match !== undefined;
        if (!isEmptyValue(prevValue.current) && Caml_obj.notequal(value, prevValue.current) && !orderSent) {
            Segment.productRemoved(Object.assign(Segment.cardToProduct(card), {
                url: document.location.href,
                purchase_instance_id: purchaseInstanceId,
                price: Belt_Int.fromString(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(prevValue.current), "0"))
            }));
        }
        if (!isEmptyValue(value) && Caml_obj.notequal(prevValue.current, value)) {
            sendSegmentProductAdded(card);
        }
        prevValue.current = value;
    }, [
        value
    ]);
}
 /* uuid Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [949,8137,7342,2769,8805,20,8213,444,8932,9774,2888,179], function() { return __webpack_exec__(86756); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);